import { render } from "./labExamReportPreview.vue?vue&type=template&id=efccbcf2&scoped=true"
import script from "./labExamReportPreview.vue?vue&type=script&lang=js"
export * from "./labExamReportPreview.vue?vue&type=script&lang=js"

import "./labExamReportPreview.vue?vue&type=style&index=0&id=efccbcf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efccbcf2"]])

export default __exports__